import {createContext} from 'react';
import {AsyncSearchModel, AsyncSearchState} from '@features/search/interfaces';

export const SearchContext = createContext<AsyncSearchModel>({
    state: AsyncSearchState.None,
    length: 0,
    showResults: () => {}
});